/* assets/cls-fixes.js */
(function (w, d) {
  'use strict';

  function getPageType() {
    if (w.__pksPageType) return w.__pksPageType;
    var b = d.body;
    if (!b || !b.classList) return '';
    if (b.classList.contains('template-collection')) return 'collection';
    if (b.classList.contains('template-search')) return 'search';
    return '';
  }

  function isMobile749() {
    try { return w.matchMedia && w.matchMedia('(max-width: 749px)').matches; }
    catch (e) { return false; }
  }

  var pt = getPageType();
  if (pt !== 'collection' && pt !== 'search') return;

  var READY_TIMEOUT_MS = 15000;
  var start = (w.performance && w.performance.now) ? w.performance.now() : Date.now();
  var finished = false;
  var observers = [];

  function disconnectAll() {
    for (var i = 0; i < observers.length; i++) {
      try { observers[i].disconnect(); } catch (e) {}
    }
    observers = [];
  }

  // Scope the "ready" signal to SS containers — never touch <html>.
  // This is what prevents the late document-wide style invalidation
  // that was anchoring LCP to ~5.7s on the promo strip.
  function markReady() {
    var selectors = [
      '#searchspring-header',
      '#searchspring-toolbar',
      '.cc-collection-products',
      '[id*="__collection-products"]',
      'custom-pagination.main-products-grid'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var els = d.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) {
        els[j].classList.add('ss-ready');
      }
    }
  }

  function done() {
    if (finished) return;
    finished = true;
    try { markReady(); } catch (e) {}
    disconnectAll();
  }

  function bodyHasSsLoaded() {
    return !!(d.body && d.body.classList && d.body.classList.contains('ss-loaded'));
  }

  function getHeader() {
    return (
      d.querySelector('#searchspring-toolbar .ss__search-header') ||
      d.querySelector('#searchspring-header .ss__search-header') ||
      d.querySelector('.ss__search-header')
    );
  }

  function hasResults() {
    return !!d.querySelector('.ss__results, .ss__results__grid, [data-ss-results]');
  }

  // PKS change start — products/blog tabs retired: blog entries no longer come
  // back from SS, so a real .ss__tabs__buttons row never renders, and this
  // placeholder was firing (and reserving its height) on every single load.
  // Left commented rather than deleted in case tabs ever come back.
  //
  // function ensureTabsPlaceholder() {
  //   if (!isMobile749()) return;
  //
  //   var header = getHeader();
  //   if (!header) return;
  //
  //   var realTabs = header.querySelector('.ss__tabs__buttons');
  //   var ph = header.querySelector('.ss__tabs__buttons--placeholder');
  //
  //   if (realTabs) {
  //     if (ph && ph.parentNode) ph.parentNode.removeChild(ph);
  //     return;
  //   }
  //   if (!ph) {
  //     var h1 = header.querySelector('h1');
  //     if (h1) {
  //       var spacer = d.createElement('div');
  //       spacer.className = 'ss__tabs__buttons ss__tabs__buttons--placeholder';
  //       spacer.setAttribute('aria-hidden', 'true');
  //       if (h1.insertAdjacentElement) h1.insertAdjacentElement('afterend', spacer);
  //       else if (h1.parentNode) h1.parentNode.insertBefore(spacer, h1.nextSibling);
  //     }
  //   }
  // }
  // PKS change end

  function isReady() {
    var mobile = isMobile749();
    if (!mobile) {
      if (!bodyHasSsLoaded()) return false;
      return !!getHeader() || hasResults();
    }
    var header = getHeader();
    if (!header) return false;
    // PKS change start — dropped the '.ss__tabs__buttons' requirement here.
    // It only ever passed because ensureTabsPlaceholder() faked a matching
    // element (its className included 'ss__tabs__buttons' itself, alongside
    // the '--placeholder' modifier). With tabs retired and that placeholder
    // no longer inserted, this would block "ready" until the 15s hard
    // timeout on every mobile load. Header + results is a sufficient signal.
    // if (!header.querySelector('.ss__tabs__buttons')) return false;
    // PKS change end
    if (!hasResults()) return false;
    return true;
  }

  // Throttle observer callbacks via rAF — collapses bursts of SS
  // mutations into one tick per frame.
  var raf = w.requestAnimationFrame || function (fn) { return w.setTimeout(fn, 16); };
  var pending = false;
  function schedule() {
    if (pending || finished) return;
    pending = true;
    raf(function () { pending = false; tick(); });
  }

  function tick() {
    if (finished) return true;
    // PKS change start — call removed along with ensureTabsPlaceholder() above;
    // nothing left to reserve tabs space for.
    // ensureTabsPlaceholder();
    // PKS change end
    if (isReady()) { done(); return true; }
    var now = (w.performance && w.performance.now) ? w.performance.now() : Date.now();
    if (now - start > READY_TIMEOUT_MS) { done(); return true; }
    return false;
  }

  function observeWhenAvailable(getEl, opts) {
    var attached = false;
    var t0 = (w.performance && w.performance.now) ? w.performance.now() : Date.now();
    function tryAttach() {
      if (finished || attached) return;
      var el = getEl();
      if (el) {
        attached = true;
        var mo = new MutationObserver(schedule);
        mo.observe(el, opts);
        observers.push(mo);
        return;
      }
      var now = (w.performance && w.performance.now) ? w.performance.now() : Date.now();
      if (now - t0 < READY_TIMEOUT_MS) w.setTimeout(tryAttach, 200);
    }
    tryAttach();
  }

  if (tick()) return;

  // Scoped observers — only SS containers, not the whole document.
  var subtreeOpts = { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] };
  observeWhenAvailable(function () { return d.getElementById('searchspring-header'); }, subtreeOpts);
  observeWhenAvailable(function () { return d.getElementById('searchspring-toolbar'); }, subtreeOpts);
  observeWhenAvailable(function () { return d.querySelector('.cc-collection-products'); }, subtreeOpts);

  // Cheap body class watcher catches the desktop 'ss-loaded' signal.
  observeWhenAvailable(function () { return d.body; }, { attributes: true, attributeFilter: ['class'] });

  w.setTimeout(function () { done(); }, READY_TIMEOUT_MS);

})(window, document);